import { styled, css } from '@compiled/react';
import { token } from '@atlaskit/tokens';

const iconStylesCompiledStyles = css({
	boxSizing: 'border-box',
	height: '24px',
	width: '24px',
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "4px" and fallback "3px" do not match and can't be replaced automatically.
	borderRadius: token('border.radius', '3px'),
});

const iconStylesWithSmallerSize = css({
	boxSizing: 'border-box',
	height: '20px',
	width: '20px',
	// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "4px" and fallback "3px" do not match and can't be replaced automatically.
	borderRadius: token('border.radius', '3px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
export const ProjectIcon = styled.img(iconStylesCompiledStyles);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
export const ProjectIconSmallerSize = styled.img(iconStylesWithSmallerSize);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
export const IconSkeleton = styled.div(iconStylesCompiledStyles, {
	backgroundColor: token('color.skeleton'),
});
